// 校园瓜田 —— 单页门户静态内容
// 主题令牌可映射的标签样式类

export interface HotItem {
  title: string;
  category: string;
  heat: number;
  discuss: number;
  summary: string;
  tag: string;
}

export interface FocusEvent {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  tags: string[];
  views: number;
  discuss: number;
  date: string;
}

export interface PickItem {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  read: string;
}

export interface CategoryInfo {
  slug: string;
  name: string;
  desc: string;
  count: number;
  icon: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteName = '校园瓜田';

export const navLinks = [
  { label: '今日热榜', anchor: 'hot' },
  { label: '焦点事件', anchor: 'focus' },
  { label: '话题分类', anchor: 'topics' },
  { label: '精选看点', anchor: 'picks' },
  { label: '吃瓜指南', anchor: 'faq' },
  { label: '关于我们', anchor: 'about' },
];

export const hotKeywords = [
  '期末占座大战',
  '社团百团招新',
  '食堂上新',
  '草坪音乐会',
  '毕业歌会',
  '图书馆通宵',
  '快递站长队',
  '校园夜跑',
  '考研自习室',
  '表白墙热议',
];

export const categories: CategoryInfo[] = [
  { slug: 'shetuan', name: '社团趣事', desc: '百团招新、社团换届、文艺演出与同好小圈子里的名场面', count: 128, icon: 'ri-music-2-line' },
  { slug: 'xuexi', name: '学习生活', desc: '自习占座、考研考研、期末冲刺与图书馆里的烟火日常', count: 186, icon: 'ri-book-open-line' },
  { slug: 'shitang', name: '食堂风波', desc: '窗口上新、黑暗料理试吃与排队长龙的高能瞬间', count: 96, icon: 'ri-restaurant-line' },
  { slug: 'sushe', name: '宿舍夜话', desc: '熄灯后的卧谈会、群聊名场面与合宿生活的酸甜苦辣', count: 142, icon: 'ri-home-5-line' },
  { slug: 'qimo', name: '期末冲刺', desc: '复习攻略、考前冲分现场与绩点保卫战的那些事', count: 104, icon: 'ri-timer-line' },
  { slug: 'biye', name: '毕业季', desc: '答辩趣闻、毕业照、散伙饭与奔赴山海前的告别', count: 88, icon: 'ri-graduation-cap-line' },
  { slug: 'huodong', name: '校园活动', desc: '晚会、运动会、草坪音乐节与操场上的青春', count: 121, icon: 'ri-megaphone-line' },
  { slug: 'redian', name: '校园热点', desc: '全校热议的头条焦点，围观要趁热，理性不掉队', count: 203, icon: 'ri-fire-line' },
];

export const hotList: HotItem[] = [
  { title: '图书馆期末占座大战又打响，凌晨五点已有人在门口排队', category: 'xuexi', heat: 98, discuss: 3214, summary: '期末周临近，图书馆座位一票难求，不少同学把占座玩出了新花样。', tag: '热' },
  { title: '百团招新现场太燃：无人机社团展示、汉服社古风快闪刷屏', category: 'shetuan', heat: 95, discuss: 2876, summary: '一年一度的社团集中招新，摊位、表演与吆喝声把操场变成了嘉年华。', tag: '爆' },
  { title: '食堂窗口上新黑暗料理：冰镇糖醋排骨成今日排队王', category: 'shitang', heat: 90, discuss: 2431, summary: '师傅创新精神拉满，同学们一边吐槽一边排起了长队。', tag: '新' },
  { title: '毕业歌会官宣：露天草坪+荧光棒，歌单投票火热进行中', category: 'huodong', heat: 87, discuss: 1987, summary: '毕业季第一场草坪音乐会开启投票，你最想听到哪一首？', tag: '热' },
  { title: '宿舍楼熄灯后集体大合唱，隔壁楼用灯牌回应的名场面', category: 'sushe', heat: 84, discuss: 1765, summary: '毕业前夜的集体仪式感，让不少人笑着笑着就红了眼眶。', tag: '暖' },
  { title: '校园猫学长顺利晋升自习室保安，靠脸吃饭还负责巡逻', category: 'redian', heat: 81, discuss: 1520, summary: '一只常年驻守自习室的猫成了全校吉祥物，围观人群络绎不绝。', tag: '萌' },
  { title: '考研自习室灯火通明，学弟学妹自发留下便签互相打气', category: 'xuexi', heat: 78, discuss: 1336, summary: '一句加油写满一整面墙，压力之下全是温柔的同路人。', tag: '暖' },
  { title: '表白墙又双叒爆了：校园跑神一个月减重十斤的打卡日记', category: 'redian', heat: 74, discuss: 1102, summary: '从宿舍到操场，跑步打卡成新潮流，评论区全是求带节奏。', tag: '卷' },
  { title: '毕业答辩现场神操作合集：预答辩一次过还反向提问老师', category: 'biye', heat: 71, discuss: 986, summary: '期末最难环节也能玩出花，应届生的松弛感令人叹服。', tag: '瓜' },
  { title: '快递站又排长龙，取件高峰期惊现代排号新职业', category: 'xuexi', heat: 68, discuss: 845, summary: '双节购物潮来袭，校园代取件经济迎来小高峰。', tag: '趣' },
  { title: '夜间操场荧光夜跑开启，跑完还有自制补给站', category: 'huodong', heat: 64, discuss: 723, summary: '当运动遇上社交，操场成了下课后的第二课堂。', tag: '动' },
  { title: '社团换届竞选现场金句频出：当部长是为了服务还是简历？', category: 'shetuan', heat: 61, discuss: 602, summary: '一场竞选演讲引发的关于学生干部初心的大讨论。', tag: '议' },
];

export const focusEvents: FocusEvent[] = [
  {
    id: 1,
    category: '学习生活',
    title: '期末周的占座经济学：凌晨排队、资料占位与图书馆里的默契',
    excerpt: '座位为何如此难抢？一张小桌承载着复习规划，也藏着同龄人之间心照不宣的规矩。我们观察了不同校区图书馆的真实生态，聊聊这背后的坚持与幽默。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20exam%20season%20study%20scene%20flat%20illustration%20with%20a%20tidy%20desk%20piled%20with%20textbooks%20notebooks%20coffee%20cup%20and%20a%20glowing%20desk%20lamp%2C%20warm%20lamplight%2C%20encouraging%20sticky%20notes%20on%20the%20wall%2C%20minimal%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20tones%2C%20cream%20textured%20paper%20background%2C%20soft%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail%20harmonious%20composition&width=900&height=640&seq=gua-focus-01&orientation=landscape',
    tags: ['期末', '占座', '学习生活'],
    views: 48600,
    discuss: 3214,
    date: '2026-09-08',
  },
  {
    id: 2,
    category: '校园活动',
    title: '百团招新盛况直击：当爱好变成一群人的高光时刻',
    excerpt: '从无人机表演到汉服快闪，从辩论队到徒步社，上百个社团把操场变成了大型同好现场。这一期带你云逛招新日，看见热爱如何把人聚在一起。',
    image: 'https://readdy.ai/api/search-image?query=Joyful%20campus%20club%20recruitment%20festival%20flat%20illustration%20with%20rows%20of%20colorful%20booth%20tents%20bunting%20flags%20balloons%20posters%20and%20small%20decorative%20props%20on%20an%20open%20field%2C%20energetic%20youthful%20atmosphere%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20clean%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail%20harmonious%20composition&width=900&height=640&seq=gua-focus-02&orientation=landscape',
    tags: ['社团', '招新', '校园活动'],
    views: 41200,
    discuss: 2876,
    date: '2026-09-07',
  },
  {
    id: 3,
    category: '毕业季',
    title: '毕业前夜的浪漫：熄灯合唱、荧光灯海与一场好好告别',
    excerpt: '当宿舍楼集体熄灯，歌声与灯牌在夜色里亮起。毕业季的仪式感不止于学士服，更在于那句没说出口的再见与整栋楼共同的奔赴。',
    image: 'https://readdy.ai/api/search-image?query=Sentimental%20graduation%20night%20flat%20illustration%20of%20a%20starry%20campus%20lawn%20at%20dusk%20with%20glowing%20string%20lights%20glowstick%20specks%20and%20a%20small%20stage%2C%20warm%20dreamy%20atmosphere%20of%20farewell%20and%20hope%2C%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20tones%2C%20deep%20warm%20background%20with%20textural%20grain%2C%20no%20people%20faces%2C%20high%20detail%20harmonious%20composition&width=900&height=640&seq=gua-focus-03&orientation=landscape',
    tags: ['毕业', '告别', '草坪音乐会'],
    views: 52800,
    discuss: 1987,
    date: '2026-09-06',
  },
];

export const picks: PickItem[] = [
  {
    id: 1,
    category: '宿舍夜话',
    title: '熄灯后大家都在聊什么？一份宿舍卧谈会选题图鉴',
    excerpt: '从选修课趣闻到室友的隐藏技能，卧谈会的话题流动速度永远比想象中快。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20dorm%20late%20night%20chat%20flat%20illustration%20with%20a%20warm%20glowing%20bedside%20lamp%20mugs%20of%20warm%20drinks%20and%20a%20small%20radio%20on%20a%20wooden%20desk%2C%20peaceful%20bedtime%20mood%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-01&orientation=landscape',
    author: '瓜田小编',
    date: '09-08',
    read: '6分钟',
  },
  {
    id: 2,
    category: '校园热点',
    title: '热度不等于真相：围观校园热点的正确姿势',
    excerpt: '吃瓜要趁热，更要清醒。怎样分辨信息真伪、避免误伤当事人，这份围观念头请收好。',
    image: 'https://readdy.ai/api/search-image?query=Thoughtful%20magnifier%20over%20news%20clippings%20and%20speech%20bubbles%20flat%20illustration%20representing%20careful%20fact%20checking%20of%20campus%20gossip%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20clean%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-02&orientation=landscape',
    author: '理性派',
    date: '09-07',
    read: '5分钟',
  },
  {
    id: 3,
    category: '食堂风波',
    title: '食堂阿姨的创新菜单，到底救了多少选择困难症？',
    excerpt: '新窗口每天都能整出新花样，让人又爱又怕。我们盘点了一周试吃日志。',
    image: 'https://readdy.ai/api/search-image?query=Playful%20cafeteria%20food%20tray%20flat%20illustration%20with%20rice%20dish%20and%20dishes%20plus%20a%20small%20steam%20and%20menu%20board%20with%20a%20heart%2C%20appetizing%20fresh%20colors%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-03&orientation=landscape',
    author: '干饭研究所',
    date: '09-06',
    read: '4分钟',
  },
  {
    id: 4,
    category: '毕业季',
    title: '毕业照拍出高级感？构图、道具与校园机位全攻略',
    excerpt: '学士服、跑道、图书馆旋转楼梯……这份机位清单让你的毕业照不撞款。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20graduation%20photography%20scene%20with%20a%20graduation%20cap%20academic%20gown%20and%20camera%20on%20a%20tripod%20near%20a%20symbolic%20school%20building%20entrance%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-04&orientation=landscape',
    author: '摄影社',
    date: '09-05',
    read: '7分钟',
  },
  {
    id: 5,
    category: '学习生活',
    title: '图书馆占座黑话大全：什么是资料占位、人肉守座',
    excerpt: '座位生态自成一套江湖语言，看完这篇你也能读懂图书馆的潜规则。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20library%20desk%20with%20a%20stack%20of%20reserved%20books%20a%20water%20bottle%20and%20a%20small%20notepad%20saying%20reserved%2C%20tidy%20study%20atmosphere%2C%20warm%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20palette%2C%20cream%20textured%20background%2C%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-05&orientation=landscape',
    author: '自习观察员',
    date: '09-04',
    read: '5分钟',
  },
  {
    id: 6,
    category: '校园活动',
    title: '草坪音乐节的正确打开方式：歌单、搭子与必备清单',
    excerpt: '天气、装备和搭子缺一不可，这份清单帮你把现场体验拉满。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20an%20outdoor%20lawn%20music%20festival%20scene%20with%20a%20small%20acoustic%20stage%20speakers%20and%20a%20picnic%20blanket%20under%20string%20lights%2C%20festive%20warm%20mood%2C%20editorial%20vector%20style%20in%20watermelon%20red%20leaf%20green%20and%20golden%20yellow%20tones%2C%20cream%20textured%20background%2C%20rounded%20shapes%2C%20no%20people%20faces%2C%20high%20detail&width=720&height=460&seq=gua-pick-06&orientation=landscape',
    author: '活动雷达',
    date: '09-03',
    read: '6分钟',
  },
];

export const faqs: FaqItem[] = [
  {
    q: '校园瓜田到底是什么？',
    a: '校园瓜田是一份面向在校学生的校园热点资讯整理。我们把分散在表白墙、朋友圈、社团群和食堂里的热议，梳理成每日更新的热榜与焦点事件，让你用几分钟就能跟上今天大家到底在聊什么。',
  },
  {
    q: '这些话题和内容从哪里来？',
    a: '内容主要来自公开的校园讨论、学生投稿与常见热点话题的再整理。我们不对任何具体个人进行点名或评判，只围绕普遍存在的校园现象与有趣事件进行中性梳理，帮助大家围观、讨论与记录。',
  },
  {
    q: '如何投稿或分享你身边的校园热点？',
    a: '欢迎通过页面底部提供的投稿邮箱把你身边真实、有趣且不涉及他人隐私的校园瞬间发给我们。入选后会收录到对应分类与热榜，并注明整理来源。我们会在发布前进行审核与脱敏处理。',
  },
  {
    q: '遇到涉及具体同学的内容会怎么处理？',
    a: '我们会严格遵守边界：凡是可能识别到具体个人、涉及隐私或未经验证的内容，一律不予发布。站内所有条目都尽量避免点名，聚焦现象与共鸣，而不是针对个体。这是我们的内容原则，也希望大家一起守住。',
  },
  {
    q: '为什么吃瓜也要讲分寸？',
    a: '围观有趣的事情无可厚非，但热度不应该以伤害他人为代价。我们希望这个栏目传递的是一种轻松的校园社交氛围：开心地吃瓜、理性地讨论、善良地表达，让每个人都能安心围观不掉队。',
  },
  {
    q: '多久更新一次？内容会核实吗？',
    a: '热点榜与焦点事件每天更新，精选看点与分类内容持续补充。所有上榜内容都会经过基础核实与常识判断，明显夸张或无法确证的说法不会被收录，做到尽量客观、克制与可信。',
  },
];